export enum THESIS_PROGRESS_STEP_ENUM {
    NOT_STARTED = 'NOT_STARTED', //ยังไม่ดำเนินการ
    SUCCESS = 'SUCCESS', //ดำเนินการ
}

export const thesis_progress_step_data = [
    {
        label: "ยังไม่ดำเนินการ",
        value: THESIS_PROGRESS_STEP_ENUM.NOT_STARTED
    },
    {
        label: "ดำเนินการ",
        value: THESIS_PROGRESS_STEP_ENUM.SUCCESS
    },
]

export enum THESIS_PROGRESS_STATUS {
    ACTIVE = "active",
    INACTIVE = "inactive"
}